// "Reading" state: the body cannot be written (the root is
// contenteditable="false"). On phones, so a long press is a plain text
// selection, as in a chat message.
//
// TipTap's `setEditable` is not used: the field's owner uses it for its own
// locks (while sending), and leaving the reading state would undo those too.
// This adds one `editable` prop; if any prop says false, the view is not
// editable. `editor.isEditable` is false while reading; whether the body is
// writable at all is `editor.options.editable`.

import type { Editor } from "@tiptap/core";
import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";

const readingModeKey = new PluginKey<boolean>("trameriaReadingMode");

export function isReadingMode(editor: Editor): boolean {
  return readingModeKey.getState(editor.state) === true;
}

/** Switches the reading state (nothing when unchanged). */
export function setReadingMode(editor: Editor, reading: boolean): void {
  if (editor.isDestroyed || isReadingMode(editor) === reading) return;
  editor.view.dispatch(
    editor.state.tr
      .setMeta(readingModeKey, reading)
      .setMeta("addToHistory", false),
  );
}

export const ReadingMode = Extension.create({
  name: "trameriaReadingMode",

  addProseMirrorPlugins() {
    return [
      new Plugin<boolean>({
        key: readingModeKey,
        state: {
          init: () => false,
          apply(tr, current) {
            const meta = tr.getMeta(readingModeKey);
            return typeof meta === "boolean" ? meta : current;
          },
        },
        props: {
          editable: (state) => readingModeKey.getState(state) !== true,
        },
      }),
    ];
  },
});
